import React from 'react';
import { toast } from 'react-toastify';
import { useQuery } from '@apollo/client';
import ErrorBoundary from 'components/common/ErrorBoundary';
import Loader from 'components/common/Loader';
import ErrorMessage from 'components/ErrorMessage';
import { Formik } from 'formik';
import { APP_UI_SETTINGS_QUERY } from 'pages/ApplicationUI/ApplicationUIGraphQL';
import {
  APP_UI,
  userVerificationDocumentValidationSchema,
} from 'pages/ApplicationUI/constant';
import NoDataFound from 'components/NoDataFound';
import UserVerificationDocumentForm from './components/UserVerificationDocumentForm';

const UserVerificationDocument = ({ saveUISetting }) => {
  const { data, loading, error, refetch } = useQuery(APP_UI_SETTINGS_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      filter: [
        {
          key: 'settingName',
          value: APP_UI.USER_VERIFICATION_DOCUMENT,
          type: 'STRING',
          op: 'EQ',
        },
        {
          key: 'isActive',
          value: true,
          type: 'BOOLEAN',
          op: 'EQ',
        },
      ],
    },
  });

  const handleSubmit = async (val) => {
    let info = {};
    if (data?.appUISettings?.appUISettings[0]?.id) {
      info = {
        id: data?.appUISettings?.appUISettings[0]?.id,
        settingName: APP_UI.USER_VERIFICATION_DOCUMENT,
        settingValue: val?.USER_VERIFICATION_DOCUMENT,
        isActive: true,
      };
    }
    try {
      await saveUISetting({
        variables: {
          appUISetting: {
            ...info,
            settingName: APP_UI.USER_VERIFICATION_DOCUMENT,
            settingValue: val?.USER_VERIFICATION_DOCUMENT,
            isActive: true,
          },
        },
      });
      refetch();
    } catch (err) {
      toast.error(err);
    }
  };
  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.appUISettings?.appUISettings)
    return <NoDataFound message="No data found" />;

  return (
    <div>
      <h4 className="f-16 fw-semibold mb-3">User Verification</h4>
      <ErrorBoundary>
        <Formik
          initialValues={{
            USER_VERIFICATION_DOCUMENT:
              data?.appUISettings?.appUISettings[0]?.settingValue || '',
          }}
          enableReinitialize
          validationSchema={userVerificationDocumentValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return <UserVerificationDocumentForm {...props} />;
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default UserVerificationDocument;
